export default __webpack_public_path__ + "static/media/avatar_grumpy_cat3.84f784c1.mp3";